export default __webpack_public_path__ + "static/media/live-score-banner-victory.aaacf2a9.jpg";